<script setup lang="ts">
import { computed } from 'vue';

import { GrammarMenuItem } from '@nora-monorepo/grammar-ui';
import type { OperationResultDTO } from '@nora-monorepo/nora-api-client';

interface OperationPickerProps {
  operations: OperationResultDTO[];
}

interface OperationPickerEmits {
  selectOperation: [operationId: string];
}

const { operations } = defineProps<OperationPickerProps>();
const emit = defineEmits<OperationPickerEmits>();

const menuItems = computed(() => {
  return operations.map(operation => ({
    label: operation.name,
    value: operation.id,
  }));
});

function onMenuSelect(value: string) {
  emit('selectOperation', value);
}
</script>

<template>
  <GrammarMenuItem
    v-for="item in menuItems"
    :key="item.value"
    :label="item.label"
    :value="item.value"
    @select="() => onMenuSelect(item.value)"
  />
</template>
